import request from '@/plugins/axios'

// การกำหนดค่าแพลตฟอร์ม

// รับข้อมูลแพลตฟอร์ม
export const apiBaseConfig = () => request.get('/settings.platform/getBaseConfig')

// ตั้งค่าข้อมูลแพลตฟอร์ม
export const apiBaseConfigEdit = (params: any) =>
    request.post('/settings.platform/setBaseConfig', params)

// รับข้อมูลการลงทะเบียนแพลตฟอร์ม
export const apiRecordConfig = () => request.get('/settings.platform/getRecordConfig')

// ตั้งค่าข้อมูลการลงทะเบียนแพลตฟอร์ม
export const apiRecordConfigEdit = (params: any) =>
    request.post('/settings.platform/setRecordConfig', params)

// การตั้งค่าระบบ

// รับรายการบันทึกของระบบ
export const apiSystemlogList = (params: any) => request.get('/settings.log/lists', { params })

// ล้างแคชของระบบ
export const apiSystemCacheClear = () => request.post('/settings.cache/clear')

// รายการงานที่กำหนดเวลาไว้
export const apiCrontabLists = (params: any) => request.get('/crontab.crontab/lists', { params })

// เพิ่มงานที่กำหนดเวลาไว้
export const apiCrontabAdd = (params: any) => request.post('/crontab.crontab/add', params)

// ตรวจสอบรายละเอียด
export const apiCrontabDetail = (params: any) => request.get('/crontab.crontab/detail', { params })

// แก้ไขงานที่กำหนดเวลาไว้
export const apiCrontabEdit = (params: any) => request.post('/crontab.crontab/edit', params)

// ลบงานที่กำหนดเวลาไว้
export const apiCrontabDel = (params: any) => request.post('/crontab.crontab/delete', params)

// รับเวลาดำเนินการกฎ
export const apiCrontabExpression = (params: any) =>
    request.get('/crontab.crontab/expression', { params })

// ดำเนินงานตามกำหนดเวลา
export const apiSrontabOperate = (params: any) => request.post('/crontab.crontab/operate', params)

/** E การบำรุงรักษาระบบ **/

/** S การอัปเดตระบบ **/
// รายการอัพเดตระบบ
export const apiSystemUpgradeLists = (params: any) =>
    request.get('/settings.upgrade/lists', { params })

// ดาวน์โหลดแพ็คเกจอัพเดต
export const apiSystemUpgradeDownloadPkg = (params: any) =>
    request.post('/settings.upgrade/downloadPkg', params)

// อัปเดตเพียงคลิกเดียว
export const apiSystemUpgrade = (params: any) => request.post('/settings.upgrade/upgrade', params)
/** E การอัปเดตระบบ **/

// สภาพแวดล้อมของระบบ
export const apiSystemSystemEnv = () => request.get('/settings.env/systemEnv')

/** S การตั้งค่าการบริการลูกค้า **/
// การได้มาซึ่งการบริการลูกค้า
export const apiServiceGet = () => request.get('/settings.service/getConfig')

// การตั้งค่าการบริการลูกค้า
export const apiServiceSet = (params: any) => request.post('/settings.service/setConfig', params)
/** E การตั้งค่าการบริการลูกค้า **/

/** S การตั้งค่าความปลอดภัย **/
// เปลี่ยนรหัสผ่านผู้ดูแลระบบ
export const apiResetPassword = (params: any) => request.post('/Login/resetPassword', params)
/** E การตั้งค่าความปลอดภัย **/

/** S บันทึกการตั้งค่า **/
// รับรายการเครื่องมือจัดเก็บข้อมูล
export const apiStorageList = (): Promise<any> => request.get('/settings.Storage/lists')

// รับข้อมูลการกำหนดค่าพื้นที่เก็บข้อมูล
export const apiStorageIndex = (params: any): Promise<any> =>
    request.get('/settings.Storage/index', { params })

// อัปเดตการกำหนดค่า
export const apiStorageSetup = (params: any): Promise<any> =>
    request.post('/settings.Storage/setup', params)

// สลับเครื่องมือจัดเก็บข้อมูลเริ่มต้น
export const apiStorageChange = (params: any): Promise<any> =>
    request.post('/settings.Storage/change', params)
/** E บันทึกการตั้งค่า **/

// การกำหนดค่าการชำระเงิน
export const apiPaymentConfigSet = (params: any): Promise<any> =>
    request.post('/settings.pay_config/setConfig', params)

// รับการกำหนดค่าการชำระเงิน
export const apiPaymentConfigGet = (params: any): Promise<any> =>
    request.get('/settings.pay_config/getConfig', { params })

// รับรายการการกำหนดค่าการชำระเงิน
export const apiPaymentConfigGetList = (): Promise<any> => request.get('/settings.pay_config/lists')
// อัปเดตวิธีการชำระเงิน
export const apiUpgradeAfter = (params: any): Promise<any> =>
    request.post('/UpgradeAfter/run', params)
